export default {
  setUser(state, user) {
    state.user = user;
    user.my_courses.forEach(course => {
      state.myCourses[course.id] = true;
    });
  },
  updateUser(state, data) {
    for (const i in data) {
      state.user[i] = data[i];
    }
  },
  setLogged(state, logged) {
    state.logged = logged;
  },

  reset(state) {
    state.user = null;
    state.logged = false;
    state.myCourses = {};
  }
};
